// extracted by mini-css-extract-plugin
export var box = "Section-module--box--969af";
export var box_md = "Section-module--box_md--b618c";
export var box_xmd = "Section-module--box_xmd--93f72";
export var box_flex = "Section-module--box_flex--41655";
export var box_lg = "Section-module--box_lg--9368a";
export var box_sm = "Section-module--box_sm--c58c4";
export var box_outer = "Section-module--box_outer--af2de";
export var box_whiteBg = "Section-module--box_white-bg--fc3f1";
export var box_noMarginBottom = "Section-module--box_no-margin-bottom--188a7";
export var box_noPadding = "Section-module--box_no-padding--dcfce";
export var box_outerGray = "Section-module--box_outer-gray--0c5e1";
export var box_dark = "Section-module--box_dark--58235";
export var box_zIndex = "Section-module--box_z-index--4f3df";
export var box_zIndex6 = "Section-module--box_z-index-6--14eb2";
export var box_eventsWithLine = "Section-module--box_events-with-line--75034";
export var box_featuresAo = "Section-module--box_features-ao--de0e0";
export var box_verticalPaddings = "Section-module--box_vertical-paddings--7d540";
export var clearP = "Section-module--clearP--4ef5c";
export var clearP_vc = "Section-module--clearP_vc--e7b25";
export var hidden = "Section-module--hidden--7eff6";
export var fadeInAnimation = "Section-module--fadeInAnimation--2f273";
export var placeHolderShimmer = "Section-module--placeHolderShimmer--5db91";